import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import DefaultProfile from '../assets/avatar.jpg';

class ProfileTabs extends Component {
    render() {
        const { following, followers, posts } = this.props;
        //console.log(this.props)
        return (
            <div className="row">
                <div className="col-md-4">
                    <h3 className="text-primary">Followers</h3>
                    <hr />
                    {followers.map((person, i) => (
                        <div key={i}>
                            <Link to={`/user/${person._id}`}>
                                <img
                                    className="mr-3 rounded-circle image-thumb"
                                    style={{ height: 50, width: 50, margin: 'auto' }}
                                    src={`${process.env.REACT_APP_API_URL}/user/photo/${person._id}`}
                                    onError={i => (i.target.src = `${DefaultProfile}`)}
                                    alt=""
                                />
                                <span>{person.name}</span>
                            </Link>
                            <p style={{ clear: 'both' }}>
                                {person.about}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="col-md-4">
                    <h3 className="text-primary">Following</h3>
                    <hr />
                    {following.map((person, i) => (
                        <div key={i}>
                            <Link to={`/user/${person._id}`}>
                                <img
                                    className="mr-3 rounded-circle image-thumb"
                                    style={{ height: 50, width: 50, margin: 'auto' }}
                                    src={`${process.env.REACT_APP_API_URL}/user/photo/${person._id}`}
                                    onError={i => (i.target.src = `${DefaultProfile}`)}
                                    alt=""
                                />
                                <span>{person.name}</span>
                            </Link>
                            <p style={{ clear: 'both' }}>
                                {person.about}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="col-md-4">
                    <h3 className="text-primary">Posts</h3>
                    <hr />
                    {posts.length ? posts.map((post, i) => (
                        <div key={i}>
                            <Link to={`/post/${post._id}`}>
                                <span className="lead">{post.title}</span>
                            </Link>
                        </div>
                    )):(
                        <h5>No posts</h5>   
                    )}
                </div>
            </div>

        )
    }
}

export default ProfileTabs;